const ApiSuffix = {
  uploadImage: '/api/upload-doc/',

  adminLogin: '/admin-api/admin-login/',
  outletLogin: '/admin-api/outlet-login/',
  updateOutletFcmToken: '/admin-api/update-outlet-fcm-token/',

  getoutlets: '/admin-api/outlet-crud/',
  addoutlet: '/admin-api/outlet-crud/',
  updateoutlet: '/admin-api/outlet-crud/',

  city: '/admin-api/city-crud/',
  pincode: '/admin-api/pincode-crud/',

  outletDeliverSlotCrud: '/admin-api/outlet-deliver-slot-crud/',

  category: '/admin-api/category-crud/',

  product: '/admin-api/product-crud/',
  productGroup: '/admin-api/product-group-crud/',
  outletProductCRUD: '/admin-api/outlet-product-crud/',
  productCRUDMapping: '/admin-api/create-delete-addon_group_from_product/',
  outletProductMapping: '/admin-api/outlet-product-crud/',

  productVariant: '/admin-api/product-variant-crud/',
  productAddon: '/admin-api/add-on-option-crud/',

  tags: '/admin-api/tags-crud/',

  addCategoryToProduct: '/admin-api/add-category-to-product/',
  addTagToProduct: '/admin-api/add-tag-to-product/',

  couponGroup: '/admin-api/coupon-group-crud/',
  coupon: '/admin-api/coupon-crud/',
  couponProductMapping: '/admin-api/coupon-product-crud/',
  couponAnalytics: '/admin-api/coupon-analytics/',

  banner: '/admin-api/banner-crud/',
  reorderBanners: '/admin-api/reorder-banners/',

  homepageHeader: '/admin-api/homepageheader-crud/',
  addProductCategoryToHomepageHeader: '/admin-api/add-product-category-to-homepage-header/',

  // Order API's
  getOrder: '/admin-api/get-date-orders/',
  getOrderDetails: '/catalogue/get-order-details/?order_id=',
  updateOrder: '/admin-api/edit-order/',

  // Addon-Header API's
  Addon: '/admin-api/addon_crud/',
  AddonGroup: '/admin-api/addon_group_crud/',

  productAddonHeaderMapping: '/admin-api/product-addon-mapping/',
  productAddonMapping: '/admin-api/product-addon-mapping/',

  // Offer API's
  itemOffer: '/admin-api/item-offer/',

  // csv
  exportCatalogue: '/admin-api/export-catalog-csv/',
  importCatalogue: '/admin-api/import-catalog-csv/',

  getAllCustomers: '/admin-api/get-all-customers/',

  popupUpdate: '/admin-api/update-popup-details/',
  sendBulkNotification: '/admin-api/send-bulk-notification/',

  getProductsOfCategory: '/admin-api/get-products-of-category/',
  reorderProductsOfCategory: '/admin-api/product-reordering/',

  getAppleDownload: '/api/get-apple-download-reports/',

  stampCrud: '/admin-api/stamp-crud/',
  stampProductMapping: '/admin-api/stampdeal-product-crud/',

  subscriptionCrud: '/admin-api/scheme-crud/',
  subscriptionProductMapping: '/admin-api/scheme-product-crud/',

  stampAnalytics: '/admin-api/get-stamp-analytics/',
  subscriptionAnalytics: '/admin-api/get-scheme-analytics/',

  reorderCategories: '/admin-api/reorder-categories/',
  reorderBanners: '/admin-api/reorder-banners/',
  reorderHomepageHeader: '/admin-api/reorder-homepage-headers/',

  getProductBySKU: '/admin-api/get-product-by-sku/',
  getProductsBySearch: '/admin-api/product-crud/',
  scanAndPayData: '/admin-api/get_scan_and_pay_data/',

  getParentCategories: '/admin-api/get-all-parent-categories/',
  getChildCategories: '/admin-api/get-all-child-categories/',

  brandCRUD: '/admin-api/brand-crud/',
  reorderBrand: '/admin-api/reorder-brands/',
  brandProductMapping: '/admin-api/brand-product-mapping-crud/',
  reorderBrandProduct: '/admin-api/reorder-brand-products/',

  accountDeletionRequest: '/customer/app-customer-deletion-request/',

  outletDashboard: '/admin-api/outlet-dashboard/',

  recheckOrderPayment: '/admin-api/recheck-order-payment/',

  walletRecharge: '/admin-api/wallet-gift-money/',
  walletRechargeVerify: '/admin-api/wallet-gift-money-otp-verify/',
  addonGroupsToProduct: '/admin-api/add-addon-group-to-products/',

  getPopupGames: '/admin-api/get-popup-games/',
  getPopupGamesPlayed: '/admin-api/get-popup-games-played/',
  getOrderFeedbacks: '/admin-api/get-order-feedbacks/',

  recheckOrderPayment: '/admin-api/recheck-order-payment/',
  recheckStampPayment: '/admin-api/recheck-stamp-payment/',

  getAbondonedStamps: '/admin-api/get-stamp-orders/',

  reedemStamp: '/admin-api/admin-redeem-stamp/',
  getCustomerStamp: '/admin-api/get-customer-stamps/',
};

export default ApiSuffix;